import { render } from "./TradeDropdown.vue?vue&type=template&id=3ec9bcf3"
import script from "./TradeDropdown.vue?vue&type=script&lang=js"
export * from "./TradeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__